import benatky_1 from "../img/stores/benatky_1-min.jpg";
import benatky_2 from "../img/stores/benatky_2-min.jpg";
import benatky_3 from "../img/stores/benatky_3-min.jpg";
import verona_1 from "../img/stores/verona_1-min.jpg";
import verona_2 from "../img/stores/verona_2-min.jpg";
import praha_1 from "../img/stores/praha_1-min.jpg";
import praha_2 from "../img/stores/praha_2-min.jpg";
import florencie_1 from "../img/stores/florencie_1-min.jpg";
import amstrdam_1 from "../img/stores/amstrdam_1-min.jpg";
import amstrdam_2 from "../img/stores/amstrdam_2-min.jpg";
import kolin_nad_rynem_1 from "../img/stores/kolin_nad_rynem_1-min.jpg";
import roma from "../img/stores/roma.webp";
import georgiaVakePark from "../img/stores/georgia-vake-park.jpg";
import georgiaCityMall from "../img/stores/georgia-city-mall.jpg";
import georgiaGrandMall from "../img/stores/georgia-grand-mall.jpg";


import prodejny_map_path_praha from "../img/stores/prodejny_map_path_praha.svg";
import prodejny_map_path_city_praha from "../img/stores/prodejny_map_path_city_praha.svg";
import prodejnyMapPathCityPrahaXs from "../img/stores/prodejny_map_path_city_praha-xs.svg";
import prodejny_map_path_benatky from "../img/stores/prodejny_map_path_benatky.svg";
import prodejny_map_path_city_benatky from "../img/stores/prodejny_map_path_city_benatky.svg";
import prodejny_map_path_city_benatkyXs from "../img/stores/prodejny_map_path_city_benatky-xs.svg";
import prodejny_map_path_verona from "../img/stores/prodejny_map_path_verona.svg";
import prodejny_map_path_city_verona from "../img/stores/prodejny_map_path_city_verona.svg";
import prodejny_map_path_city_veronaXs from "../img/stores/prodejny_map_path_city_verona-xs.svg";
import prodejny_map_path_amsterdam from "../img/stores/prodejny_map_path_amsterdam.svg";
import prodejny_map_path_city_amsterdam from "../img/stores/prodejny_map_path_city_amsterdam.svg";
import prodejny_map_path_city_amsterdamXs from "../img/stores/prodejny_map_path_city_amsterdam-xs.svg";
import prodejny_map_path_florencie from "../img/stores/prodejny_map_path_florencie.svg";
import prodejny_map_path_city_florencie from "../img/stores/prodejny_map_path_city_florencie.svg";
import prodejny_map_path_city_florencieXs from "../img/stores/prodejny_map_path_city_florencie-xs.svg";
import prodejny_map_path_kolin from "../img/stores/prodejny_map_path_kolin.svg";
import prodejny_map_path_city_kolin from "../img/stores/prodejny_map_path_city_kolin.svg";
import prodejny_map_path_city_kolinXs from "../img/stores/prodejny_map_path_city_kolin-xs.svg";
import prodejny_map_path_city_georgia from "../img/stores/prodejny_map_path_georgia.svg";
import prodejny_map_path_georgia_road from "../img/stores/prodejny_map_path_georgia_road.svg";
import prodejny_map_path_rome from "../img/stores/prodejny_map_path_rome.svg";
import prodejny_map_path_city_rome from "../img/stores/prodejny_map_path_city_rome.svg";
import prodejny_map_path_city_rome_xs from "../img/stores/prodejny_map_path_city_rome-xs.svg";

const StorsData = {
    en: [
        {
            id: "georgia",
            title: "Our stores in Georgia",
            places: [
                {
                    img: georgiaVakePark,
                    title: "4 Archil Mishveladze str, Tbilisi",
                    link: "https://www.google.com/maps/search/Archil+Mishveladze+4+Tbilisi+Georgia",
                    linkName: "Show on map",
                    table: [
                        {
                            open: "Monday - Sunday",
                            time: "10:00—22:00",
                        },
                    ]
                },
                {
                    img: georgiaCityMall,
                    title: "70 Vazha Pshavela Ave, City Mall, Tbilisi",
                    link: "https://www.google.com/maps/search/70+Vazha+Pshavela+Ave+City+Mall+Tbilisi+Georgia",
                    linkName: "Show on map",
                    table: [
                        {
                            open: "Monday - Sunday",
                            time: "10:00—22:00",
                        },
                    ]
                },
                {
                    img: georgiaGrandMall,
                    title: "29 Sherif Khimshiashvili str, Grand Mall, Batumi",
                    link: "https://www.google.com/maps/search/29+Sherif+Khimshiashvili+Grand+Mall+Batumi+Georgia",
                    linkName: "Show on map",
                    table: [
                        {
                            open: "Monday - Sunday",
                            time: "10:00—22:00",
                        },
                    ]
                },
            ]
        },
        {
            id: "cologne",
            title: "Our stores in Cologne",
            places: [
                {
                    img: kolin_nad_rynem_1,
                    title: "Hohe Strasse 120-122",
                    link: "https://goo.gl/maps/uXA2JgDoJj8kYCj26",
                    linkName: "Show on map",
                    table: [
                        {
                            open: "Monday - Saturday",
                            time: "11:00—20:00",
                        },
                        {
                            open: "Sunday",
                            time: "closed",
                        },
                    ]
                },
            ]
        },
        {
            id: "venecie",
            title: "Our stores in Venice",
            places: [
                {
                    img: benatky_1,
                    title: "Salizada San Giovanni Grisostomo 5803",
                    link: "https://www.google.cz/maps/place/Salizada+S.+Giovanni+Grisostomo,+5803,+30121+Venezia+VE,+It%C3%A1lie/@45.4390141,12.3349899,17z/data=!3m1!4b1!4m5!3m4!1s0x477eb1dbee572bd1:0x87490efe04ea7997!8m2!3d45.4390141!4d12.3371786",
                    linkName: "Show on map",
                    table: [
                        {
                            open: "Monday - Thursday",
                            time: "10:00—22:00",
                        },
                        {
                            open: "Friday - Saturday",
                            time: "10:00—23:00",
                        },
                        {
                            open: "Sunday",
                            time: "10:00—22:00",
                        },
                    ]
                },
                {
                    img: benatky_2,
                    title: "San Marco 5037",
                    link: "https://www.google.cz/maps/place/S.+Marco,+4742-4743,+30100+Venezia+VE,+It%C3%A1lie/@45.4362713,12.3335094,17z/data=!3m1!4b1!4m5!3m4!1s0x477eb1da159153df:0x4a162b15fe2576a6!8m2!3d45.4362676!4d12.3356981",
                    linkName: "Show on map",
                    table: [
                        {
                            open: "Monday - Thursday",
                            time: "10:00—22:00",
                        },
                        {
                            open: "Friday - Saturday",
                            time: "10:00—23:00",
                        },
                        {
                            open: "Sunday",
                            time: "10:00—22:00",
                        },
                    ]
                },
                {
                    img: benatky_3,
                    title: "Castello 5577/5578",
                    link: "https://www.google.cz/maps/place/S.+Marco,+4742-4743,+30100+Venezia+VE,+It%C3%A1lie/@45.4362713,12.3335094,17z/data=!3m1!4b1!4m5!3m4!1s0x477eb1da159153df:0x4a162b15fe2576a6!8m2!3d45.4362676!4d12.3356981",
                    linkName: "Show on map",
                    table: [
                        {
                            open: "Monday - Thursday",
                            time: "10:00—22:00",
                        },
                        {
                            open: "Friday - Saturday",
                            time: "10:00—23:00",
                        },
                        {
                            open: "Sunday",
                            time: "10:00—22:00",
                        },
                    ]
                },
            ]
        },
        {
            id: "prague",
            title: "Our stores in Prague",
            places: [
                {
                    img: praha_1,
                    title: "Na Příkopě 10",
                    link: "https://goo.gl/maps/XFnaAuFP8e82",
                    linkName: "Show on map",
                    closet: "Temporarily closed",
                    // table: [
                    //     {
                    //         open: "Monday - Sunday",
                    //         time: "10:00—21:00",
                    //     },
                    // ]
                },
                {
                    img: praha_2,
                    title: "Karlova 7",
                    link: "https://goo.gl/maps/3c9qQmG18m82",
                    linkName: "Show on map",
                    table: [
                        {
                            open: "Monday - Sunday",
                            time: "10:00—21:00",
                        },
                    ]
                },
            ]
        },
        {
            id: "verona",
            title: "Our stores in Verona",
            places: [
                {
                    img: verona_1,
                    title: "Via Cappello 6",
                    link: "https://www.google.cz/maps/place/Via+Cappello,+6,+37121+Verona+VR,+It%C3%A1lie/@45.4420786,10.9979177,21z/data=!4m5!3m4!1s0x477f5f490033de7d:0x547252f32b8cb95d!8m2!3d45.4420523!4d10.9979918",
                    linkName: "Show on map",
                    table: [
                        {
                            open: "Monday - Thursday",
                            time: "10:00—21:00",
                        },
                        {
                            open: "Friday - Saturday",
                            time: "10:00—22:00",
                        },
                        {
                            open: "Sunday",
                            time: "10:00—21:00",
                        },
                    ]
                },
                {
                    img: verona_2,
                    title: "Via Mazzini 78",
                    link: "https://goo.gl/maps/dPopaAr6mCsU2APZ8",
                    linkName: "Show on map",
                    table: [
                        {
                            open: "Monday - Thursday",
                            time: "10:00—21:00",
                        },
                        {
                            open: "Friday - Saturday",
                            time: "10:00—22:00",
                        },
                        {
                            open: "Sunday",
                            time: "10:00—21:00",
                        },
                    ]
                },
            ]
        },
        {
            id: "rome",
            title: "Our stores in Rome",
            places: [
                {
                    img: roma,
                    title: "Via delle Muratte",
                    link: "https://www.google.com/maps/place/Via+dei+Calzaiuoli,+42,+50122+Firenze+FI,+It%C3%A1lie/@43.7707921,11.2554196,17z/data=!3m1!4b1!4m5!3m4!1s0x132a54010999f27b:0xaf2f378a984f75f2!8m2!3d43.7707921!4d11.2554196?hl=cs-CZ",
                    linkName: "Show on map",
                    table: [
                        {
                            open: "Monday - Thursday",
                            time: "10:00—21:00",
                        },
                        {
                            open: "Friday - Saturday",
                            time: "10:00—22:00",
                        },
                        {
                            open: "Sunday",
                            time: "10:00—21:00",
                        },
                    ]
                },
            ]
        },
        {
            id: "florence",
            title: "Our stores in Florence",
            places: [
                {
                    img: florencie_1,
                    title: "Via dei Calzaiuoli 42 Rosso",
                    link: "https://www.google.com/maps/place/Via+dei+Calzaiuoli,+42,+50122+Firenze+FI,+It%C3%A1lie/@43.7707921,11.2554196,17z/data=!3m1!4b1!4m5!3m4!1s0x132a54010999f27b:0xaf2f378a984f75f2!8m2!3d43.7707921!4d11.2554196?hl=cs-CZ",
                    linkName: "Show on map",
                    table: [
                        {
                            open: "Monday - Thursday",
                            time: "10:00—21:00",
                        },
                        {
                            open: "Friday - Saturday",
                            time: "10:00—22:00",
                        },
                        {
                            open: "Sunday",
                            time: "10:00—21:00",
                        },
                    ]
                },
            ]
        },
        {
            id: "amsterdam",
            title: "Our stores in Amsterdam",
            places: [
                {
                    img: amstrdam_1,
                    title: "Kalverstraat 80-82",
                    link: "https://www.google.com/maps/place/Kalverstraat+80,+1012+PH+Amsterdam,+Nizozemsko/@52.3706901,4.8914355,21z/data=!4m5!3m4!1s0x47c609c11f22fbf3:0x99f1192a9efc529b!8m2!3d52.3706901!4d4.8915723",
                    linkName: "Show on map",
                    table: [
                        {
                            open: "Monday",
                            time: "11:00—20:00",
                        },
                        {
                            open: "Tuesday",
                            time: "10:00—20:00",
                        },
                        {
                            open: "Wednesday",
                            time: "10:00—20:00",
                        },
                        {
                            open: "Thursday",
                            time: "10:00—21:00",
                        },
                        {
                            open: "Friday",
                            time: "10:00—20:00",
                        },
                        {
                            open: "Saturday",
                            time: "10:00—20:00",
                        },
                        {
                            open: "Sunday",
                            time: "11:00—20:00",
                        },
                    ]
                },
                {
                    img: amstrdam_2,
                    title: "Nieuwendijk 169",
                    link: "https://goo.gl/maps/BG12c4EqxvjW9SGx8",
                    linkName: "Show on map",
                    table: [
                        {
                            open: "Monday",
                            time: "11:00—20:00",
                        },
                        {
                            open: "Tuesday",
                            time: "10:00—20:00",
                        },
                        {
                            open: "Wednesday",
                            time: "10:00—20:00",
                        },
                        {
                            open: "Thursday",
                            time: "10:00—21:00",
                        },
                        {
                            open: "Friday",
                            time: "10:00—20:00",
                        },
                        {
                            open: "Saturday",
                            time: "10:00—20:00",
                        },
                        {
                            open: "Sunday",
                            time: "11:00—20:00",
                        },
                    ]
                },
            ]
        },
    ],
    ka: [
        {
            id: "georgia",
            title: "ჩვენი მაღაზიები საქართველოში",
            places: [
                {
                    img: georgiaVakePark,
                    title: "არჩილ მიშველაძის ქუჩა #4, ვაკის პარკი, თბილისი",
                    link: "https://www.google.com/maps/search/Archil+Mishveladze+4+Tbilisi+Georgia",
                    linkName: "რუკაზე ნახვა",
                    table: [
                        {
                            open: "ორშაბათი - კვირა",
                            time: "10:00—22:00",
                        },
                    ]
                },
                {
                    img: georgiaCityMall,
                    title: "ვაჟა-ფშაველას გამზირი #70, სითი მოლი, თბილისი",
                    link: "https://www.google.com/maps/search/70+Vazha+Pshavela+Ave+City+Mall+Tbilisi+Georgia",
                    linkName: "რუკაზე ნახვა",
                    table: [
                        {
                            open: "ორშაბათი - კვირა",
                            time: "10:00—22:00",
                        },
                    ]
                },
                {
                    img: georgiaGrandMall,
                    title: "შერიფ ხიმშიაშვილის ქუჩა #29, გრანდ მოლი, ბათუმი",
                    link: "https://www.google.com/maps/search/29+Sherif+Khimshiashvili+Grand+Mall+Batumi+Georgia",
                    linkName: "რუკაზე ნახვა",
                    table: [
                        {
                            open: "ორშაბათი - კვირა",
                            time: "10:00—22:00",
                        },
                    ]
                },
            ]
        },
        {
            id: "cologne",
            title: "ჩვენი მაღაზიები კიოლნში",
            places: [
                {
                    img: kolin_nad_rynem_1,
                    title: "Hohe Straße 120-122",
                    link: "https://goo.gl/maps/uXA2JgDoJj8kYCj26",
                    linkName: "რუკაზე ნახვა",
                    table: [
                        {
                            open: "ორშაბათი - შაბათი",
                            time: "11:00—20:00",
                        },
                        {
                            open: "კვირა",
                            time: "დაკეტილია",
                        },
                    ]
                },
            ]
        },
        {
            id: "venecie",
            title: "ჩვენი მაღაზიები ვენეციაში",
            places: [
                {
                    img: benatky_1,
                    title: "Salizada San Giovanni Grisostomo 5803",
                    link: "https://www.google.cz/maps/place/Salizada+S.+Giovanni+Grisostomo,+5803,+30121+Venezia+VE,+It%C3%A1lie/@45.4390141,12.3349899,17z/data=!3m1!4b1!4m5!3m4!1s0x477eb1dbee572bd1:0x87490efe04ea7997!8m2!3d45.4390141!4d12.3371786",
                    linkName: "რუკაზე ნახვა",
                    table: [
                        {
                            open: "ორშაბათი – ხუთშაბათი",
                            time: "10:00—22:00",
                        },
                        {
                            open: "პარასკევი - შაბათი",
                            time: "10:00—23:00",
                        },
                        {
                            open: "კვირა",
                            time: "10:00—22:00",
                        },
                    ]
                },
                {
                    img: benatky_2,
                    title: "San Marco 5037",
                    link: "https://www.google.cz/maps/place/S.+Marco,+4742-4743,+30100+Venezia+VE,+It%C3%A1lie/@45.4362713,12.3335094,17z/data=!3m1!4b1!4m5!3m4!1s0x477eb1da159153df:0x4a162b15fe2576a6!8m2!3d45.4362676!4d12.3356981",
                    linkName: "რუკაზე ნახვა",
                    table: [
                        {
                            open: "ორშაბათი - ხუთშაბათი",
                            time: "10:00—22:00",
                        },
                        {
                            open: "პარასკევი - შაბათი",
                            time: "10:00—23:00",
                        },
                        {
                            open: "კვირა",
                            time: "10:00—22:00",
                        },
                    ]
                },
                {
                    img: benatky_3,
                    title: "Castello 5577/5578",
                    link: "https://www.google.cz/maps/place/S.+Marco,+4742-4743,+30100+Venezia+VE,+It%C3%A1lie/@45.4362713,12.3335094,17z/data=!3m1!4b1!4m5!3m4!1s0x477eb1da159153df:0x4a162b15fe2576a6!8m2!3d45.4362676!4d12.3356981",
                    linkName: "რუკაზე ნახვა",
                    table: [
                        {
                            open: "ორშაბათი - ხუთშაბათი",
                            time: "10:00—22:00",
                        },
                        {
                            open: "პარასკევი - შაბათი",
                            time: "10:00—23:00",
                        },
                        {
                            open: "კვირა",
                            time: "10:00—22:00",
                        },
                    ]
                },
            ]
        },
        {
            id: "prague",
            title: "ჩვენი მაღაზიები პრაღაში",
            places: [
                {
                    img: praha_1,
                    title: "Na Příkopě 10",
                    link: "https://goo.gl/maps/XFnaAuFP8e82",
                    linkName: "რუკაზე ნახვა",
                    closet: "დროებით დაკეტილია",
                    // table: [
                    //     {
                    //         open: "Montag - Sonntag",
                    //         time: "10:00—21:00",
                    //     },
                    // ]
                },
                {
                    img: praha_2,
                    title: "Karlova 7",
                    link: "https://goo.gl/maps/3c9qQmG18m82",
                    linkName: "რუკაზე ნახვა",
                    table: [
                        {
                            open: "ორშაბათი - კვირა",
                            time: "10:00—21:00",
                        },
                    ]
                },
            ]
        },
        {
            id: "verona",
            title: "ჩვენი მაღაზიები ვერონაში",
            places: [
                {
                    img: verona_1,
                    title: "Via Cappello 6",
                    link: "https://www.google.cz/maps/place/Via+Cappello,+6,+37121+Verona+VR,+It%C3%A1lie/@45.4420786,10.9979177,21z/data=!4m5!3m4!1s0x477f5f490033de7d:0x547252f32b8cb95d!8m2!3d45.4420523!4d10.9979918",
                    linkName: "რუკაზე ნახვა",
                    table: [
                        {
                            open: "ორშაბათი - ხუთშაბათი",
                            time: "10:00—21:00",
                        },
                        {
                            open: "პარასკევი - შაბათი",
                            time: "10:00—22:00",
                        },
                        {
                            open: "კვირა",
                            time: "10:00—21:00",
                        },
                    ]
                },
                {
                    img: verona_2,
                    title: "Via Mazzini 78",
                    link: "https://goo.gl/maps/dPopaAr6mCsU2APZ8",
                    linkName: "რუკაზე ნახვა",
                    table: [
                        {
                            open: "ორშაბათი - ხუთშაბათი",
                            time: "10:00—21:00",
                        },
                        {
                            open: "პარასკევი - შაბათი",
                            time: "10:00—22:00",
                        },
                        {
                            open: "კვირა",
                            time: "10:00—21:00",
                        },
                    ]
                },
            ]
        },
        {
            id: "rome",
            title: "ჩვენი მაღაზიები რომში",
            places: [
                {
                    img: roma,
                    title: "Via delle Muratte",
                    link: "https://www.google.com/maps/place/Via+dei+Calzaiuoli,+42,+50122+Firenze+FI,+It%C3%A1lie/@43.7707921,11.2554196,17z/data=!3m1!4b1!4m5!3m4!1s0x132a54010999f27b:0xaf2f378a984f75f2!8m2!3d43.7707921!4d11.2554196?hl=cs-CZ",
                    linkName: "რუკაზე ნახვა",
                    table: [
                        {
                            open: "ორშაბათი - ხუთშაბათი",
                            time: "10:00—21:00",
                        },
                        {
                            open: "პარასკევი - შაბათი",
                            time: "10:00—22:00",
                        },
                        {
                            open: "კვირა",
                            time: "10:00—21:00",
                        },
                    ]
                },
            ]
        },
        {
            id: "florence",
            title: "ჩვენი მაღაზიები ფლორენციაში",
            places: [
                {
                    img: florencie_1,
                    title: "Via dei Calzaiuoli 42 Rosso",
                    link: "https://www.google.com/maps/place/Via+dei+Calzaiuoli,+42,+50122+Firenze+FI,+It%C3%A1lie/@43.7707921,11.2554196,17z/data=!3m1!4b1!4m5!3m4!1s0x132a54010999f27b:0xaf2f378a984f75f2!8m2!3d43.7707921!4d11.2554196?hl=cs-CZ",
                    linkName: "რუკაზე ნახვა",
                    table: [
                        {
                            open: "ორშაბათი - ხუთშაბათი",
                            time: "10:00—21:00",
                        },
                        {
                            open: "პარასკევი - შაბათი",
                            time: "10:00—22:00",
                        },
                        {
                            open: "კვირა",
                            time: "10:00—21:00",
                        },
                    ]
                },
            ]
        },
        {
            id: "amsterdam",
            title: "ჩვენი მაღაზიები ამსტერდამში",
            places: [
                {
                    img: amstrdam_1,
                    title: "Kalverstraat 80-82",
                    link: "https://www.google.com/maps/place/Kalverstraat+80,+1012+PH+Amsterdam,+Nizozemsko/@52.3706901,4.8914355,21z/data=!4m5!3m4!1s0x47c609c11f22fbf3:0x99f1192a9efc529b!8m2!3d52.3706901!4d4.8915723",
                    linkName: "რუკაზე ნახვა",
                    table: [
                        {
                            open: "ორშაბათი",
                            time: "11:00—20:00",
                        },
                        {
                            open: "სამშაბათი",
                            time: "10:00—20:00",
                        },
                        {
                            open: "ოთხშაბათი",
                            time: "10:00—20:00",
                        },
                        {
                            open: "ხუთშაბათი",
                            time: "10:00—21:00",
                        },
                        {
                            open: "პარასკევი",
                            time: "10:00—20:00",
                        },
                        {
                            open: "შაბათი",
                            time: "10:00—20:00",
                        },
                        {
                            open: "კვირა",
                            time: "11:00—20:00",
                        },
                    ]
                },
                {
                    img: amstrdam_2,
                    title: "Nieuwendijk 169",
                    link: "https://goo.gl/maps/BG12c4EqxvjW9SGx8",
                    linkName: "რუკაზე ნახვა",
                    table: [
                        {
                            open: "ორშაბათი",
                            time: "11:00—20:00",
                        },
                        {
                            open: "სამშაბათი",
                            time: "10:00—20:00",
                        },
                        {
                            open: "ოთხშაბათი",
                            time: "10:00—20:00",
                        },
                        {
                            open: "ხუთშაბათი",
                            time: "10:00—21:00",
                        },
                        {
                            open: "პარასკევი",
                            time: "10:00—20:00",
                        },
                        {
                            open: "შაბათი",
                            time: "10:00—20:00",
                        },
                        {
                            open: "კვირა",
                            time: "11:00—20:00",
                        },
                    ]
                },
            ]
        },
    ],
};

const cities = {
    en: [
        {
            id: "path-verona",
            scrollId: "verona",
            name: "verona",
            path: prodejny_map_path_verona,
            img: prodejny_map_path_city_verona,
            imgXs: prodejny_map_path_city_veronaXs,
        },
        {
            id: "path-kolin",
            scrollId: "cologne",
            name: "Cologne",
            path: prodejny_map_path_kolin,
            img: prodejny_map_path_city_kolin,
            imgXs: prodejny_map_path_city_kolinXs,
        },
        {
            id: "path-praha",
            scrollId: "prague",
            name: "Praha",
            path: prodejny_map_path_praha,
            img: prodejny_map_path_city_praha,
            imgXs: prodejnyMapPathCityPrahaXs,
        },
        {
            id: "path-benatky",
            scrollId: "venecie",
            name: "Venice",
            path: prodejny_map_path_benatky,
            img: prodejny_map_path_city_benatky,
            imgXs: prodejny_map_path_city_benatkyXs,
        },
        {
            id: "path-florencie",
            scrollId: "florence",
            name: "Florence",
            path: prodejny_map_path_florencie,
            img: prodejny_map_path_city_florencie,
            imgXs: prodejny_map_path_city_florencieXs,
        },
        {
            id: "path-rome",
            scrollId: "rome",
            name: "Roma",
            path: prodejny_map_path_rome,
            img: prodejny_map_path_city_rome,
            imgXs: prodejny_map_path_city_rome_xs,
        },
        {
            id: "path-georgia",
            scrollId: "georgia",
            name: "Georgia",
            path: prodejny_map_path_georgia_road,
            pathClass: "prodejny-map-path-georgia",
            img: prodejny_map_path_city_georgia,
            imgXs: prodejny_map_path_city_georgia,
        },
        {
            id: "path-amsterdam",
            scrollId: "amsterdam",
            name: "Amsterdam",
            path: prodejny_map_path_amsterdam,
            img: prodejny_map_path_city_amsterdam,
            imgXs: prodejny_map_path_city_amsterdamXs,
        },
    ],
    ka: [
        {
            id: "path-verona",
            scrollId: "verona",
            name: "ვერონა",
            path: prodejny_map_path_verona,
            img: prodejny_map_path_city_verona,
            imgXs: prodejny_map_path_city_veronaXs,
        },
        {
            id: "path-kolin",
            scrollId: "cologne",
            name: "კიოლნი",
            path: prodejny_map_path_kolin,
            img: prodejny_map_path_city_kolin,
            imgXs: prodejny_map_path_city_kolinXs,
        },
        {
            id: "path-praha",
            scrollId: "prague",
            name: "პრაღა",
            path: prodejny_map_path_praha,
            img: prodejny_map_path_city_praha,
            imgXs: prodejnyMapPathCityPrahaXs,
        },
        {
            id: "path-benatky",
            scrollId: "venecie",
            name: "ვენეცია",
            path: prodejny_map_path_benatky,
            img: prodejny_map_path_city_benatky,
            imgXs: prodejny_map_path_city_benatkyXs,
        },
        {
            id: "path-florencie",
            scrollId: "florence",
            name: "ფლორენცია",
            path: prodejny_map_path_florencie,
            img: prodejny_map_path_city_florencie,
            imgXs: prodejny_map_path_city_florencieXs,
        },
        {
            id: "path-rome",
            scrollId: "rome",
            name: "რომი",
            path: prodejny_map_path_rome,
            img: prodejny_map_path_city_rome,
            imgXs: prodejny_map_path_city_rome_xs,
        },
        {
            id: "path-georgia",
            scrollId: "georgia",
            name: "საქართველო",
            path: prodejny_map_path_georgia_road,
            pathClass: "prodejny-map-path-georgia",
            img: prodejny_map_path_city_georgia,
            imgXs: prodejny_map_path_city_georgia,
        },
        {
            id: "path-amsterdam",
            scrollId: "amsterdam",
            name: "ამსტერდამი",
            path: prodejny_map_path_amsterdam,
            img: prodejny_map_path_city_amsterdam,
            imgXs: prodejny_map_path_city_amsterdamXs,
        },
    ],
};


export {
    StorsData, cities,
}
